function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close.svg'; // eslint-disable-next-line @typescript-eslint/ban-types

class Dialog extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      isVisible: false
    });

    _defineProperty(this, "showDialog", options => {
      this.setState({
        options,
        isVisible: true
      });
    });

    _defineProperty(this, "hideDialog", () => {
      this.setState({
        isVisible: false
      });
    });
  }

  render() {
    const {
      isVisible,
      options
    } = this.state;
    const {
      showCloseIcon,
      onCloseIconPress,
      icon,
      title,
      description,
      primaryButton,
      onPrimaryButtonPress
    } = options || {};
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.backdrop, isVisible && styles.show)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.modal
    }, showCloseIcon ? /*#__PURE__*/React.createElement("button", {
      className: styles.close,
      onClick: onCloseIconPress || this.hideDialog
    }, /*#__PURE__*/React.createElement("img", {
      src: icCloseIcon
    })) : null, icon ? /*#__PURE__*/React.createElement("div", {
      className: styles.iconContainer
    }, /*#__PURE__*/React.createElement("img", {
      src: icon
    })) : null, /*#__PURE__*/React.createElement("span", {
      className: styles.title
    }, title), /*#__PURE__*/React.createElement("span", {
      className: styles.description
    }, description), /*#__PURE__*/React.createElement("div", {
      className: styles.buttonGroup
    }, /*#__PURE__*/React.createElement("button", {
      className: classNames(styles.button, styles.primary),
      onClick: onPrimaryButtonPress || this.hideDialog
    }, primaryButton || 'Close'))));
  }

}

export default Dialog;